exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spec-table[data-v-7fd2cfd8]{width:100%}.spec-table td[data-v-7fd2cfd8]{padding:3px}.list p[data-v-7fd2cfd8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:0}.list[data-v-7fd2cfd8]:nth-child(2n){background:#f7f7f7}.work-img img[data-v-7fd2cfd8]{width:50px;height:50px;border-radius:4px;display:block}\n", ""]);

// exports
